import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Avatar,
  IconButton,
  Grid,
  Paper,
  Divider,
  Select,
  MenuItem,


  Button,
  ListItemIcon,
  ListItemText,
  Menu,
} from "@mui/material";
import { KeyboardArrowDown, Logout, Notifications, Person, Settings } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import LabelDisplay from "../../FrontEnd/UpdateChange/LabelDisplay";
import { useNavigate } from "react-router-dom";
import { getValue, LoacalVariables } from "../../commonFunctions/CommonFunctions";
import LogoutDialog from "./LogoutDialog";
import { useDashboard } from "../../Context/DashboardContext";


const Navbar: React.FC = () => {

  const { data } = useDashboard();
  const userName: any = getValue(LoacalVariables.Name);
  const userType: any = getValue(LoacalVariables.UserType);
  const email: any = getValue(LoacalVariables.Email);

  const [notifOpen, setNotifOpen] = useState(false);
  const [notifFilter, setNotifFilter] = useState("today");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);

  const navigate = useNavigate();

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    handleProfileMenuClose();
    setLogoutConfirmOpen(true);
  };

  const notifications = data?.lowStockList ? data.lowStockList.map((item) => ({
    id: item.ItemId,
    message: `${item.ItemName} is low on stock (Qty: ${item.Quantity})`,
    time: `Reorder level: ${item.ReorderLevel}`,
  })) : [];

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          background: "#f9fafb",
          color: "#000",
          borderBottom: "1px solid #e5e7eb",
          transition: "all 0.3s ease",
          p: 2,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          { }
          <Grid container alignItems="center">
            <Grid item xs={12} sm={7}>
              <LabelDisplay />
            </Grid>
          </Grid>

          { }
          <Box display="flex" alignItems="center" sx={{ position: "relative" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                background: "#fff",
                px: 2,
                py: 1,
                borderRadius: "16px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                transition: "all 0.2s ease",
                "&:hover": {
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                },
              }}
            >
              { }
              <Box
                onClick={handleProfileMenuOpen}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  cursor: "pointer",
                  "&:hover": {
                    opacity: 0.8,
                  },
                }}
              >
                <Avatar
                  sx={{
                    width: 40,
                    height: 40,
                    bgcolor: "#6366f1",
                    background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                  }}
                >
                  {userName.charAt(0).toUpperCase()}
                </Avatar>

                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <Typography fontSize={14} fontWeight={600} color="#1f2937">
                    {userName}
                  </Typography>
                  <Typography fontSize={12} color="#6b7280">
                    {userType}
                  </Typography>
                </Box>

                <KeyboardArrowDown
                  sx={{
                    fontSize: 20,
                    color: "#9ca3af",
                    display: { xs: "none", sm: "block" },
                  }}
                />
              </Box>

              { }
              <IconButton
                onClick={() => setNotifOpen((prev) => !prev)}
                sx={{
                  ml: 1,
                  background: "#f3f4f6",
                  position: "relative",
                  "&:hover": {
                    background: "#e5e7eb",
                  },
                }}
              >
                <Notifications sx={{ color: "#4b5563" }} />
                <Box
                  sx={{
                    position: "absolute",
                    top: 6,
                    right: 6,
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "#ef4444",
                    border: "1px solid #fff",
                  }}
                />
              </IconButton>
            </Box>

            { }
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleProfileMenuClose}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 200,
                  borderRadius: 2,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                  border: "1px solid #f0f0f0",
                },
              }}
            >
              <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                <Typography variant="body2" fontWeight={600} color="#1f2937">
                  {userName}
                </Typography>
                <Typography variant="caption" color="#6b7280">
                  {email}
                </Typography>
              </Box>

              {/* <MenuItem
                onClick={() => {
                  handleProfileMenuClose();
                  navigate("/profile");
                }}
                sx={{ py: 1 }}
              >
                <ListItemIcon>
                  <Person sx={{ fontSize: 20, color: "#6366f1" }} />
                </ListItemIcon>
                <ListItemText>My Profile</ListItemText>
              </MenuItem> */}

              {/* <MenuItem
                onClick={() => {
                  handleProfileMenuClose();
                  navigate("/settings");
                }}
                sx={{ py: 1 }}
              >
                <ListItemIcon>
                  <Settings sx={{ fontSize: 20, color: "#6366f1" }} />
                </ListItemIcon>
                <ListItemText>Settings</ListItemText>
              </MenuItem> */}

              <Divider />

              <MenuItem
                onClick={handleLogoutClick}
                sx={{
                  py: 1,
                  color: "#ef4444",
                  "&:hover": {
                    backgroundColor: "#fef2f2",
                  },
                }}
              >
                <ListItemIcon>
                  <Logout sx={{ fontSize: 20, color: "#ef4444" }} />
                </ListItemIcon>
                <ListItemText>Logout</ListItemText>
              </MenuItem>
            </Menu>

            { }
            {notifOpen && (
              <Paper
                elevation={4}
                sx={{
                  position: "absolute",
                  top: 56,
                  right: 0,
                  width: 340,
                  borderRadius: 3,
                  zIndex: 1400,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
                  overflow: "hidden",
                  animation: "slideDown 0.2s ease",
                  "@keyframes slideDown": {
                    from: {
                      opacity: 0,
                      transform: "translateY(-10px)",
                    },
                    to: {
                      opacity: 1,
                      transform: "translateY(0)",
                    },
                  },
                }}
              >
                { }
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  px={2.5}
                  pt={2.5}
                  pb={1.5}
                  sx={{ borderBottom: "1px solid #f0f0f0" }}
                >
                  <Typography fontWeight={700} fontSize="1.2rem" color="#1f2937">
                    Notifications
                  </Typography>
                  <IconButton
                    onClick={() => setNotifOpen(false)}
                    size="small"
                    sx={{
                      background: "#f3f4f6",
                      width: 28,
                      height: 28,
                      "&:hover": { background: "#e5e7eb" },
                    }}
                  >
                    <CloseIcon sx={{ fontSize: 16, color: "#6b7280" }} />
                  </IconButton>
                </Box>

                { }
                {/* <Box px={2.5} pb={1.5} pt={1.5}>
                  <Select
                    value={notifFilter}
                    onChange={(e) => setNotifFilter(e.target.value)}
                    size="small"
                    fullWidth
                    sx={{
                      borderRadius: "20px",
                      fontSize: "0.875rem",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "20px",
                        borderColor: "#e5e7eb",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d1d5db",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6366f1",
                        borderWidth: "1px",
                      },
                    }}
                  >
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="week">This Week</MenuItem>
                    <MenuItem value="month">This Month</MenuItem>
                  </Select>
                </Box> */}

                <Divider />

                { }
                <Box sx={{ maxHeight: 360, overflowY: "auto" }}>
                  {notifications.length > 0 ? (
                    notifications.map((n, index) => (
                      <React.Fragment key={n.id}>
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          gap={1.5}
                          px={2.5}
                          py={2}
                          sx={{
                            "&:hover": {
                              backgroundColor: "#f9fafb",
                              cursor: "pointer",
                            },
                          }}
                        >
                          <WarningAmberIcon
                            sx={{
                              color: "#f59e0b",
                              fontSize: 22,
                              mt: 0.2,
                              flexShrink: 0,
                            }}
                          />

                          <Box flex={1}>
                            <Typography
                              fontWeight={600}
                              fontSize="0.875rem"
                              mb={0.5}
                              color="#374151"
                            >
                              {n.message}
                            </Typography>

                            <Typography fontSize="0.75rem" color="#9ca3af">
                              {n.time}
                            </Typography>
                          </Box>
                        </Box>

                        {index < notifications.length - 1 && <Divider />}
                      </React.Fragment>
                    ))
                  ) : (
                    <Box sx={{ py: 4, textAlign: "center" }}>
                      <Typography color="#9ca3af" fontSize="0.875rem">
                        No notifications
                      </Typography>
                    </Box>
                  )}
                </Box>

                { }
                {/* <Box
                  sx={{
                    p: 2,
                    textAlign: "center",
                    borderTop: "1px solid #f0f0f0",
                    backgroundColor: "#f9fafb",
                  }}
                >
                  <Button
                    size="small"
                    sx={{
                      color: "#6366f1",
                      textTransform: "none",
                      fontWeight: 600,
                      "&:hover": {
                        backgroundColor: "transparent",
                        textDecoration: "underline",
                      },
                    }}
                    onClick={() => {
                      setNotifOpen(false);
                      navigate("/notifications");
                    }}
                  >
                    View All Notifications
                  </Button>
                </Box> */}
              </Paper>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      <LogoutDialog logoutConfirmOpen={logoutConfirmOpen} setLogoutConfirmOpen={setLogoutConfirmOpen} />
    </>
  );
};

export default Navbar;